/**
 * Shallows (ตื้น): stretches of an authored layout's water given a depth class (the `deep` layer: 1 shallow, 2
 * swimming depth) so that they are waded into from the bank before the water gets deep (qinggong.ts
 * `waterDepthAt`, data/qinggong.ts `WATER`). Inside `rect` (x0, x1, y0, y1 in the layout's metres), a water tile
 * fewer than `wade` metres from dry ground (along its row or column) is class 1, fewer than `swim` class 2; the rest
 * keeps its class. Applied by layout.ts when the layout is built (WATER-CLIMB round 2a).
 */
export interface Shallows {
  readonly layout: string;
  readonly name: string;
  readonly rect: readonly [number, number, number, number];
  readonly wade: number;
  readonly swim: number;
}

export const SHALLOWS: readonly Shallows[] = [
  // Yanyu B: the river's west bank south of สะพานลาน, by the ferry pier (landmarks pier / pierWest): a wading beach.
  { layout: 'yanyu2', name: 'หาดลุยน้ำริมท่าเรือ', rect: [366, 384, 304, 340], wade: 4, swim: 7 },
];
